// utils
import { getCurrentDate } from "src/utils/dateHelper";

// cache store
import configure from "src/utils/store";

async function fetchNearByEvents(_data) {
  let now = getCurrentDate();

  let data = {
    userId: 0,
    accessToken: "",
    latitude: _data?.lat || "36.1251958",
    longitude: _data?.lng || "-115.3150848",
    radius: _data?.radius || 50,
    time: now.prettier.dateTimeNow,
  };

  const api = await configure();

  const response = await api(
    {
      method: "POST",
      url: `/NewNearByEvents`,
      data: data,
      params: data.categoryId,
    },
    { cache: { maxAge: 5 * 60 * 1000 } }
  );

  return response;
}

export { fetchNearByEvents };
